export const JIRA_SOFTWARE_PATH_PREFIX = '/jira/software';
export const JIRA_BUSINESS_PATH_PREFIX = '/jira/core';
export const JIRA_SOFTWARE_CMP_PATH_PREFIX = '/jira/software/c';
